// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__yK95J","label":"style_label__b2IN5","phone":"style_phone__DdsyQ","error":"style_error__UzyRb"};